export const GET_SUMMARY = 'GET_SUMMARY';
export const GET_TRANSACTIONS = 'GET_TRANSACTIONS';
export const GET_SALES = 'GET_SALES';
export const GET_TRANSACTIONS_PER_HOUR = 'GET_TRANSACTIONS_PER_HOUR';
export const GET_ORDER_TYPES = 'GET_ORDER_TYPES';
export const LOADING = 'LOADING';
